<section *removeIfUnauthorized="['Application Administrator', 'NESS Administrator', 'CDS Approver']">
  <h1>NESS Administration</h1>
  <p-tabView #tabVw (onChange)="onChangeTab($event)" [(activeIndex)]="activeIndex">
    <p-tabPanel header="Manage Users" *removeIfUnauthorized="['Application Administrator', 'NESS Administrator']" [cache]="true">
      <ng-template pTemplate="content">
        <ness-approvals></ness-approvals>
        <ness-manage-users></ness-manage-users>
        <ness-user-list (onChange)="tabVw.onChange.emit($event)"></ness-user-list>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Bulk Import" *removeIfUnauthorized="['NESS Administrator']" [cache]="true">
      <ng-template pTemplate="content">
        <ness-bulk-imports></ness-bulk-imports>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Manage Supervisors" *removeIfUnauthorized="['NESS Administrator']" [cache]="true">
      <ng-template pTemplate="content">
        <ness-manage-supervisors></ness-manage-supervisors>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Manage FD Leadership" *removeIfUnauthorized="['NESS Administrator']" [cache]="true">
      <ng-template pTemplate="content">
        <ness-manage-leadership></ness-manage-leadership>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Manage FD Groups" *removeIfUnauthorized="['NESS Administrator']" [cache]="true">
      <ng-template pTemplate="content">
        <ness-manage-fd-groups></ness-manage-fd-groups>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Manage Agencies" *removeIfUnauthorized="['NESS Administrator']" [cache]="true">
      <ng-template pTemplate="content">
        <ness-manage-agency></ness-manage-agency>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Manage Templates" *removeIfUnauthorized="['NESS Administrator']" [cache]="true">
      <ng-template pTemplate="content">
        <ness-manage-attachments></ness-manage-attachments>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Manage ElasticSearch" *removeIfUnauthorizedDevMode="{name:'es', expectedVal:'on',role:['NESS Administrator']}" [cache]="true">
      <ng-template pTemplate="content">
        <ness-manage-elasticsearch></ness-manage-elasticsearch>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Manage My Agency" *removeIfUnauthorized="['CDS Approver']" [cache]="true">
      <ng-template pTemplate="content">
        <ness-manage-my-agency></ness-manage-my-agency>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</section>
